import { adjustCorporateUnusedDistributedCredits } from '../../../api/corporateApi'
import translate from '../../../i18n'
import {
  CorporateUnusedDistributedCreditsRequest,
  ICorporate,
} from '../../../pages/corporates-container/share-type'
import styles from '../credits-notes-form/credits-notes-form.module.less'
import { Button, Form, InputNumber, Modal, notification, Slider, Space } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import React, { useEffect, useState } from 'react'

interface IProps {
  corporate: ICorporate
  visible: boolean
  onCancel: () => void
  onSubmit: () => void
}

const CorporateUnusedDistributedCreditsModal = (props: IProps) => {
  const { corporate, visible, onCancel, onSubmit } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [computedCredits, setComputedCredits] = useState<number>()
  const [maxUnusedDistributedCredits, setMaxUnusedDistributedCredits] = useState<number>()
  const [unusedDistributedCreditsMarks, setUnusedDistributedCreditsMarks] = useState<any>()

  const [form] = Form.useForm()

  useEffect(() => {
    if (visible) {
      form.setFieldValue('unusedDistributedCredits', corporate.unusedDistributedCredits)

      const maxUnusedDistributedCredits = corporate.credits + corporate.unusedDistributedCredits
      const unusedDistributedCreditsMarks = { 0: 0 } as any
      unusedDistributedCreditsMarks[maxUnusedDistributedCredits] = maxUnusedDistributedCredits

      setMaxUnusedDistributedCredits(maxUnusedDistributedCredits)
      setUnusedDistributedCreditsMarks(unusedDistributedCreditsMarks)
    }
  }, [corporate, visible])

  const unusedDistributedCredits = Form.useWatch('unusedDistributedCredits', form)

  useEffect(() => {
    setComputedCredits(
      corporate.credits +
        corporate.unusedDistributedCredits -
        form.getFieldValue('unusedDistributedCredits'),
    )
  }, [unusedDistributedCredits])

  const onFinish = (value: CorporateUnusedDistributedCreditsRequest) => {
    if (!corporate) {
      return
    }
    setLoading(true)
    adjustCorporateUnusedDistributedCredits(corporate.id, value)
      .then(() => {
        notification.success({
          message: translate('corporate.credits.adjustUnusedDistributedCredits'),
          description: translate('corporate.credits.adjustUnusedDistributedCreditsSuccess'),
        })
        onSubmit()
      })
      .catch(err => {
        notification.error({
          message: translate('corporate.credits.adjustUnusedDistributedCredits'),
          description:
            err?.message || translate('corporate.credits.adjustUnusedDistributedCreditsFailed'),
        })
      })
      .finally(() => {
        setLoading(false)
        onCancel()
      })
  }

  return (
    <Modal
      centered
      open={visible}
      footer={null}
      width={800}
      forceRender
      title={translate('corporate.credits.adjustUnusedDistributedCredits')}
      onCancel={onCancel}
    >
      <Form
        layout="horizontal"
        name="adjust-unused-distributed-credits-form"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 10 }}
        onFinish={onFinish}
        autoComplete="off"
        form={form}
      >
        <Form.Item label={translate('corporate.credits')}>
          <InputNumber disabled value={computedCredits} />
        </Form.Item>
        <Form.Item
          name="unusedDistributedCredits"
          label={translate('corporate.unusedDistributedCredits')}
        >
          <Slider
            min={0}
            max={maxUnusedDistributedCredits}
            marks={unusedDistributedCreditsMarks}
            tooltip={{ open: visible }}
          />
        </Form.Item>
        <Form.Item name="notes" label={translate('corporate.notes')}>
          <TextArea placeholder={translate('corporate.notes.placeholder')} showCount />
        </Form.Item>
        <Form.Item label=" " colon={false}>
          <Space className={styles['button-group']}>
            <Button loading={loading} type="primary" htmlType="submit">
              {translate('submit')}
            </Button>
            <Button onClick={onCancel}>{translate('cancel')}</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CorporateUnusedDistributedCreditsModal
